import React, { useState } from "react";
import { Button, Menu, MenuItem, Chip, Stack } from "@mui/material";
import { SUBMISSION_LINK } from "../../../common/constants/submissionLink";
const SubmissionLinkEditor = ({ rowId, value, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [links, setLinks] = useState(value || []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddLink = (link) => {
    if (links.find((item) => item.title === link.title)) {
      return;
    }
    const newLinks = [...links, link];
    setLinks(newLinks);
    onChange(rowId, "submissionLinks", newLinks);
    handleClose();
  };

  const handleDeleteLink = (index) => {
    const newLinks = links.filter((_, i) => i !== index);
    setLinks(newLinks);
    onChange(rowId, "submissionLinks", newLinks);
  };

  return (
    <div>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        선택하기
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {SUBMISSION_LINK.map((link, index) => (
          <MenuItem key={index} onClick={() => handleAddLink(link)}>
            {link.title}
          </MenuItem>
        ))}
      </Menu>
      <Stack direction="column" spacing={1}>
        {links.map((link, index) => (
          <Chip
            key={index}
            label={link.title}
            onDelete={() => handleDeleteLink(index)}
          />
        ))}
      </Stack>
    </div>
  );
};

export default SubmissionLinkEditor;
